import store from '@/store'

export default {
  methods: {
    dcCan(action) {
      if (store.state.currentRoleCode === 'SUPER_ADMIN') return true
      const p = store.state.dcPermissions
      if (!p || !p.length) return true
      return p.indexOf(action) >= 0
    },
    dcMenuAllowed(path) {
      if (store.state.currentRoleCode === 'SUPER_ADMIN') return true
      const keys = store.state.dcMenuKeys
      if (!keys || !keys.length) return true
      const perm = String(path || '').replace(/^\//, '')
      return keys.indexOf(perm) >= 0 || keys.indexOf('/' + perm) >= 0 || keys.indexOf(path) >= 0
    }
  }
}
